<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="产品文案"
      :showFooter="false"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <!-- // 业务 -->
      <el-table
        stripe
        :header-cell-style="{backgroundColor: '#F4F8FB'}"
        :data="allTableData"
        border
      >
        <el-table-column label="文件" prop="files" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-upload
              action=""
              :before-upload="beforeUpload"
              :http-request="handleHttp"
              :show-file-list="false"
              v-if="!scope.row.fileRoute || scope.row.isEditing">
              <el-link type="primary" :underline="false" @click="activeRow=scope.$index">
                {{scope.row.fileName ? scope.row.fileName : '上传'}}
              </el-link>
            </el-upload>
            <el-link type="primary" :underline="false" v-else @click="downLoad(scope.row)">{{scope.row.fileName}}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="更新说明" prop="updateInstructions" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input v-model="scope.row.updateInstructions" v-if="!scope.row.fileRoute || scope.row.isEditing"></el-input>
            <span v-else>{{scope.row.updateInstructions}}</span>
          </template>
        </el-table-column>
        <el-table-column label="撰写人" prop="writerUserId" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.writerUserId"
              filterable=""
              placeholder="请选择"
              v-if="!scope.row.fileRoute || scope.row.isEditing"
              >
              <el-option
                v-for="item in userList"
                :key="item.userId"
                :label="`${item.userName}${item.workNo ? '-' + item.workNo : ''}`"
                :value="item.userId">
              </el-option>
            </el-select>
            <span v-else>{{scope.row.writerUserName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="上传时间" prop="uploadTime" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.uploadTime|formatDate('YYYY-MM-DD HH:mm:ss')}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作人" prop="operator" show-overflow-tooltip width="80px"></el-table-column>
        <el-table-column label="操作" width="150px">
          <template slot-scope="scope">
            <template v-if="!scope.row.fileRoute || scope.row.isEditing">
              <el-link :underline="false" type="primary" @click="save(scope.row)">保存</el-link>
              <el-divider direction="vertical"></el-divider>
              <el-link :underline="false" type="info" @click="cancel(scope.row, scope.$index)">取消</el-link>
            </template>
            <template v-else>
              <el-link :underline="false" type="primary" @click="downLoad(scope.row)">下载</el-link>
              <el-divider direction="vertical"></el-divider>
              <el-link :underline="false" type="primary" @click="edit(scope.row)">编辑</el-link>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: center; margin: 10px 0;">
        <el-button type="primary" size="small" @click="add" v-permission="`ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$addProductPaperwork`">新增</el-button>
      </div>
    </q-dialog>
  </div>
</template>

<script>
import axios from "@/utils/axiosInstance";
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible', 'spuId'],
  data() {
    return {
      // 业务
      tableData: [],
      tempTableData: [],
      userList: [],
      activeRow: '',
      isNeedRefresh: false
    }
  },
  computed: {
    ...mapGetters({
      userName: 'name'
    }),
    allTableData() {
      return [...this.tableData, ...this.tempTableData]
    },
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    }
  },
  mounted() {
    // 业务
    this.init();
    this.getUserList()
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      if (this.isNeedRefresh) {
        this.$emit('success');
      }
      this.$emit('close');
    },
    confirm() {
      this.updateVal();
    },
    // 业务
    init() {
      let data = {
        spuId: this.spuId,
        type: '6'
      }
      this.$q.newProduct.queryProductDataCopywriting({params: data})
      .then(res=>{
        this.tableData = res.data;
      })
    },
    add() {
      this.tempTableData.push({
        fileName: '',
        files: null,
        updateInstructions: this.allTableData.length ? '' : '新增',
        uploadTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        timeStamp: moment().format('x'),
        operator: this.userName
      })
    },
    beforeUpload(file) {
      const isLt50M = file.size / 1024 / 1024 < 50;

      if (!isLt50M) {
        this.$message.error('上传文件大小不能超过 50MB!');
      }
      return isLt50M;
    },
    handleHttp(file) {
      console.log(file);
      // 判断是编辑已有行还是新增行
      if (this.activeRow < this.tableData.length) {
        // 编辑模式：更新 tableData 中的行
        this.$set(this.tableData[this.activeRow], 'files', file.file);
        this.$set(this.tableData[this.activeRow], 'fileName', file.file.name);
      } else {
        // 新增模式：更新 tempTableData 中的行
        this.tempTableData[this.activeRow - this.tableData.length].files = file.file;
        this.tempTableData[this.activeRow - this.tableData.length].fileName = file.file.name;
      }
    },
    save(row) {
      // 新增模式下必须上传文件
      if(!row.isEditing && !row.files) {
        this.$message.error('请上传文件');
        return;
      }
      if(!row.updateInstructions) {
        this.$message.error('请填写更新说明');
        return;
      }
      if(!row.writerUserId) {
        this.$message.error('请选择撰写人');
        return;
      }
      this.tempTableData = this.tempTableData.filter(v=>v.timeStamp !== row.timeStamp)
      let data = {
        spuId: this.spuId,
        updateInstructions: row.updateInstructions,
        uploadTime: row.isEditing ? moment().format('YYYY-MM-DD HH:mm:ss') : row.uploadTime,
        operator: row.isEditing ? this.userName : row.operator,
        writerUserId: row.writerUserId,
        type: '6',
        fileId: row.fileId  || ''
      }
      // 如果有新文件，则添加到 data 中
      if(row.files) {
        data.files = row.files;
      }
      // 如果是编辑模式，添加 id
      if(row.isEditing && row.id) {
        data.id = row.id;
      }
      this.$q.newProduct.newProductArrivalUpload({data}, true)
      .then(res=>{
        if(res.code == 200) {
          this.isNeedRefresh = true;
          this.$message.success(row.isEditing ? '更新成功' : '上传成功')
        }else{
          this.$message.error(res.message)
        }
        this.init();
      })
    },
    edit(row) {
      // 进入编辑模式
      this.$set(row, 'isEditing', true);
      // 清空文件，允许重新上传
      this.$set(row, 'files', null);
    },
    cancel(row, index) {
      // 如果是编辑模式，退出编辑状态
      if (row.isEditing) {
        this.$set(row, 'isEditing', false);
      } else {
        // 如果是新增模式，从临时数组中移除
        this.tempTableData = this.tempTableData.filter(v => v.timeStamp !== row.timeStamp);
      }
      // 重新获取列表
      this.init();
    },
    getUserList() {
      let data = {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "getUserInfoByName",
      }
      axios.post(`/ec-pc-api/custom/reports/data/getUserInfoByName`, data).then((res) => {
        if (res.code == 200) {
          this.userList = res.data.list;
        }
      });
    },
    downLoad(row) {
      let url = row.fileRoute;
      let fileName = row.fileName;
      var xhr = new XMLHttpRequest();
      xhr.open("GET",url, true);
      xhr.responseType = "blob";
      xhr.onload = function() {
        if (xhr.status === 200) {
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(xhr.response, fileName);
          } else {
            var link = document.createElement("a");
            var body = document.querySelector("body");

            link.href = window.URL.createObjectURL(xhr.response);
            link.download = fileName;

            // fix Firefox
            link.style.display = "none";
            body.appendChild(link);

            link.click();
            body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
          }
        }
      };
      xhr.send();
    }
  }
}
</script>

<style lang="stylus" scoped>
  >>> .el-upload-list__item:first-child
    margin-top 0px
  >>> .el-upload-list__item
    margin-top 0px
  >>> .el-upload-list__item-name
    margin-right 0px
</style>